import DataService from '@/service/DataService'

const state = {
  status: {},
  geraete: [],
  adminGeraete: []
}

const getters = {
  geraeteStatus: (state) => state.status,
  geraete: (state) => state.geraete,
  adminGeraete: (state) => state.adminGeraete
};

const actions = {
  // GET
  fetchAlleGeraete({ commit }) {
    commit('GETALLEGERAETEREQUEST')

    return DataService.getAlleGeraete()
      .then(res => {
        commit('GETALLEGERAETESUCCESS', res.data)
      })
      .catch(err => {
        commit('GETALLEGERAETEFAILURE', err)
      })
  },
  fetchBenutzerGeraete({ commit }) {
    commit('GETBENUTZERGERAETEREQUEST')

    return DataService.getBenutzerGeraete()
      .then(res => {
        commit('GETBENUTZERGERAETESUCCESS', res.data)
      })
      .catch(err => {
        commit('GETBENUTZERGERAETEFAILURE', err)
      })
  },

  // POST
  addGeraet({commit}, geraet) {
    commit('ADDGERAETREQUEST')

    return DataService.createGeraet(geraet)
    .then(res => {
      commit('ADDGERAETSUCCESS', res.data)
    })
    .catch(err => {
      commit('ADDGERAETFAILURE', err)
    })
  },

  // PUT
  updGeraet({commit}, geraet) {
    commit('UPDATEGERAETREQUEST')

    return DataService.updateGeraet(geraet)
    .then(res => {
      commit('UPDATEGERAETSUCCESS', res.data)
    })
    .catch(err => {
      commit('UPDATEGERAETFAILURE', err)
    })
  },

  // DELETE
  removeGeraet({commit}, geraeteId) {
    commit('DELETEGERAETREQUEST')

    return DataService.deleteGeraet(geraeteId)
    .then(() => {
      commit('DELETEGERAETSUCCESS', geraeteId)
    })
    .catch(err => {
      commit('DELETEGERAETFAILURE', err)
    })
  }
};

const mutations = {
  GETALLEGERAETEREQUEST: (state) => { state.status = { gettingAlleGeraete: true}},
  GETALLEGERAETESUCCESS: (state, res) => {
    state.status = {}
    state.adminGeraete = res
  },
  GETALLEGERAETEFAILURE: (state, err) => {state.status = { errMsg: err}},
  GETBENUTZERGERAETEREQUEST: (state) => {state.status = { gettingBenutzerGereate: true }},
  GETBENUTZERGERAETESUCCESS: (state, res) => {
    state.status = {}
    state.geraete = res
  },
  GETBENUTZERGERAETEFAILURE: (state, err) => {state.status = {errMsg: err}},
  ADDGERAETREQUEST: (state) => {state.status = { creatingGeratetypen: true }},
  ADDGERAETSUCCESS: (state, res) => {
    state.status = {}
    state.geraete.push(res)
  },
  ADDGERAETFAILURE: (state, err) => {state.status = {errMsg: err}},
  UPDATEGERAETREQUEST: (state) => {state.status = {updatingGeraet: true}},
  UPDATEGERAETSUCCESS: (state, res) => {
    state.status = {}

    let index = state.geraete.findIndex(x => x.id == res.id)
    let adminIndex = state.adminGeraete.findIndex(x => x.id == res.id)

    if (index != null) {
      state.geraete.splice(index, 1)
      state.geraete.push(res)
    }

    if(adminIndex != null) {
      state.adminGeraete.splice(adminIndex, 1)
      state.adminGeraete.push(res)
    }
  },
  UPDATEGERAETFROMSIGFOX: (state, data) => {
    state.geraete.forEach(geraet => {
      if (geraet.sigfoxDeviceId == data.sigfoxDeviceId) {
        geraet.sigfoxPositionId = data.sigfoxPositionId
        geraet.anzahlPositionAbfragen = data.anzahlPositionAbfragen
      }
    })
  },
  UPDATEGERAETFAILURE: (state, err) => {state.status = {errMsg: err}},
  DELETEGERAETREQUEST: (state) => {state.status = { deletingGeratetypen: true }},
  DELETEGERAETSUCCESS: (state, res) => {
    state.status = {}

    let index = state.geraete.findIndex(x => x.id == res)
    let adminIndex = state.adminGeraete.findIndex(x => x.id == res)
    if (index != null) state.geraete.splice(index, 1)
    if(adminIndex != null) state.adminGeraete.splice(adminIndex, 1)
  },
  DELETEGERAETFAILURE: (state, err) => {state.status = {errMsg: err}},
};

export default {
  state,
  getters,
  actions,
  mutations
}